import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import pic1 from './Media/UNICEF-logo.png'
import pic2 from './Media/ssss.png'
import pic3 from './Media/e-cash (1).png'
import pic4 from './Media/e-lira-logo (1).png'
import pic5 from './Media/mtn.png'
import pic6 from './Media/fatoora.png'
import pic7 from './Media/cham.png'
import pic8 from './Media/barakeh.png'
import pic9 from './Media/removebg-preview.png'
import pic10 from './Media/last.png'
import pic11 from './Media/azrak_1000099_profile-removebg-preview.png'

import { useTranslation } from "react-i18next";

export default function ContactedCompanies() {
  const { t } = useTranslation();

  return (
    <div id={t('Business Cooperation')}>
      <Box sx={{ flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center', display: 'flex',textAlign:'center'}}>
          <Typography
              sx={{
                color: 'white',
                fontSize: '35px',
                marginTop:'100px'
              }}
            >
        {t('Services and Business Cooperation')}
            </Typography>
            </Box>

        <Container sx={{
            marginTop:'50px',
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "70px",
          }}>
            <img src={pic1} style={{ width:'150px',height:'150px',objectFit:'contain' }}/>
            <img src={pic2} style={{ width:'150px',height:'150px',objectFit:'contain' }}/>
            <img src={pic3} style={{ width:'150px',height:'150px',objectFit:'contain' }}/>
            <img src={pic4} style={{ width:'150px',height:'150px',objectFit:'contain' }}/>
            <img src={pic5} style={{ width:'150px',height:'150px',objectFit:'contain' }}/>
            <img src={pic6} style={{ width:'150px',height:'150px',objectFit:'contain' }}/>
            <img src={pic7} style={{ width:'150px',height:'150px',objectFit:'contain' }}/>
            <img src={pic8} style={{ width:'150px',height:'150px',objectFit:'contain' }}/>
            <img src={pic9} style={{ width:'150px',height:'150px',objectFit:'contain' }}/>
            <img src={pic10} style={{ width:'150px',height:'150px',objectFit:'contain' }}/>
            <img src={pic11} style={{ width:'150px',height:'150px',objectFit:'contain' }}/>
        </Container>
    </div>
  )
}
